/*eslint-disable */
import axios from "axios";
import React from 'react';
import http from "./http";
import { Route } from 'react-router-dom';
import  config from './config';
export const filterContant =async () => {
        
         /* const requestOptions = {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ project_id:Number(localStorage.getItem(urlElements[4]+"_project_id")) })
    }; */
    const urlElements = window.location.href.split('/');
    const params = Object.fromEntries(new URLSearchParams(window.location.search));
    let lang = 'en';
    if (params.lang !== undefined && ['en', 'es'].includes(params.lang) >= 0) {
        lang = params.lang;
    }
    let projectString = urlElements[4];
    if (projectString.indexOf('?') >= 1 && (urlElements[3] === 'egm' || urlElements[3] === 'egm-draft' || urlElements[3] === 'egm-embedded')) {
        const projectStringArray = projectString.split('?');
        [projectString] = projectStringArray;
    }

    return http.post(config.url + 'map_filters', { project_id: Number(localStorage.getItem(projectString +"_project_id")), lang:lang })
    .then( ( response ) => response )
    .catch( ( ) => '' );
};
